var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-warning",
    viewBox: "0 0 37 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32l18.526-32 18.526 32h-37.053zM4.379 29.474h28.295l-14.147-24.421-14.147 24.421zM18.702 27.074c0.36 0 0.659-0.122 0.898-0.365s0.358-0.545 0.358-0.905c0-0.36-0.122-0.659-0.365-0.898s-0.545-0.358-0.905-0.358c-0.36 0-0.659 0.122-0.898 0.365s-0.358 0.545-0.358 0.905 0.122 0.659 0.365 0.898c0.244 0.239 0.545 0.358 0.905 0.358zM17.432 22.4h2.526v-9.432h-2.526v9.432z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.f1c82023e493f4d8f407062c341d4610.svg";
export { ForwardRef as ReactComponent };